import { urlConfig } from "../../config/urlConfig";
import { FieldsModel } from "../../types/FieldsModel";
import { MetadataDefinitionGridModel } from "../../types/MetadataDefinitionGridModel";
import { PreworkDetailViewModel } from "../../types/PreworkDetailsViewModel";
import { PreWorkInstructionModel } from "../../types/PreWorkInstructionModel";
import { PreworkSummaryListDetailsViewModel } from "../../types/PreworkSummaryListDetailsViewModel";
import {
  postCall,
  postCallFormDataNote,
  postCallSaveUpdateDeleteExcelData,
  postFileDownloadCall,
} from "../httpService";

export const GetPreWorkDetails = async (
  params: PreworkSummaryListDetailsViewModel
) => {
  try {
    const response = await postCall(urlConfig.PreworkDetails, params);
    return response.data;
  } catch (error) {
    console.log("Error in GetPreWorkDetails data fetching ", error);
    throw error;
  }
};

export const GetDownloadFiles = async (downloadFilePayLoad: any) => {
  try {
    const response = await postFileDownloadCall(
      urlConfig.PreworkDetailDownloadDocument,
      downloadFilePayLoad
    );
    return response;
  } catch (error) {
    console.error("Error fetching GetDownloadFiles", error);
    throw error;
  }
};

export const RenameFiles = async (params: PreworkDetailViewModel) => {
  try {
    const response = await postCall(urlConfig.RenameFiles, params);
    return response.data;
  } catch (error) {
    console.log("Error in RenameFiles ", error);
    throw error;
  }
};

export const RejectFiles = async (params: any) => {
  try {
    const response = await postCall(urlConfig.RejectFiles, params);
    return response.data;
  } catch (error) {
    console.log("Error in RejectFiles ", error);
    throw error;
  }
};

export const AddInstructions = async (params: any) => {
  try {
    const response = await postCall(
      urlConfig.PreDetailsAddinstructionsText,
      params
    );
    return response.data;
  } catch (error) {
    console.log("Error in AddInstructions ", error);
    throw error;
  }
};

export const DeleteFiles = async (params: PreworkDetailViewModel[]) => {
  try {
    const response = await postCall(urlConfig.DeleteFiles, params);
    return response.data;
  } catch (error) {
    console.log("Error in DeleteFiles ", error);
    throw error;
  }
};

export const AcceptPreworkDetails = async (
  params: PreworkDetailViewModel[]
) => {
  try {
    const response = await postCall(urlConfig.AcceptPreworkDetails, params);
    return response.data;
  } catch (error) {
    console.log("Error in AcceptPreworkDetails ", error);
    throw error;
  }
};

export const MoveToPreflight = async (params: any) => {
  try {
    const response = await postCall(urlConfig.MoveToPreflight, params);
    return response.data;
  } catch (error) {
    console.log("Error in MoveToPreflight ", error);
    throw error;
  }
};

export const GetPreWorkInstructions = async (
  params: PreWorkInstructionModel
) => {
  try {
    const response = await postCall(urlConfig.GetPreWorkInstructions, params);
    return response.data;
  } catch (error) {
    console.log("Error in GetPreWorkInstructions ", error);
    throw error;
  }
};

export const MoveFileToFinal = async (
  params: PreworkSummaryListDetailsViewModel[]
) => {
  try {
    const response = await postCall(urlConfig.MoveToFinalFolder, params);
    return response.data;
  } catch (error) {
    console.log("Error in MoveFileToFinal ", error);
    throw error;
  }
};

export const TriggerProofWorkFlow = async (
  params: PreworkSummaryListDetailsViewModel[]
) => {
  try {
    const response = await postCall(urlConfig.TriggerProofWorkFlow, params);
    return response.data;
  } catch (error) {
    console.log("Error in TriggerProofWorkFlow ", error);
    throw error;
  }
};

export const TriggerProdWorkFlow = async (
  params: PreworkSummaryListDetailsViewModel[]
) => {
  try {
    const response = await postCall(urlConfig.TriggerProdWorkFlow, params);
    return response.data;
  } catch (error) {
    console.log("Error in TriggerProdWorkFlow ", error);
    throw error;
  }
};

export const ReprocessFileMoveToPreflight = async (params: any) => {
  try {
    const response = await postCall(
      urlConfig.ReprocessFileMoveToPreflight,
      params
    );
    return response.data;
  } catch (error) {
    console.log("Error in ReprocessFileMoveToPreflight ", error);
    throw error;
  }
};

export const SaveUpdateContextMenu = async (params: any) => {
  try {
    const response = await postCallSaveUpdateDeleteExcelData(params);
    return response.data;
  } catch (error) {
    console.log("Error in SaveUpdateContextMenu ", error);
    throw error;
  }
};

export const GetMetadataOrderdefinition = async (params: any) => {
  try {
    const response = await postCall(
      urlConfig.GetMetadataOrderdefinition,
      params
    );
    return response.data;
  } catch (error) {
    console.log("Error in GetMetadataOrderdefinition ", error);
    throw error;
  }
};

export const GetEditMetadataOrderdefinition = async (
  params: MetadataDefinitionGridModel
) => {
  try {
    const response = await postCall(
      urlConfig.GetEditMetadataOrderdefinition,
      params
    );
    return response.data;
  } catch (error) {
    console.log("Error in GetEditMetadataOrderdefinition ", error);
    throw error;
  }
};

export const SaveDocViewDetails = async (params: FieldsModel[]) => {
  try {
    const response = await postCall(urlConfig.DocViewSaveDetails, params);
    return response.data;
  } catch (error) {
    console.log("Error in SaveDocViewDetails ", error);
    throw error;
  }
};

export const AddNoteWithFile = async (params: any) => {
  try {
    const response = await postCallFormDataNote(params);
    return response.data;
  } catch (error) {
    console.log("Error in AddNote ", error);
    throw error;
  }
};

export const SaveAndSubmit = async (params: any) => {
  try {
    const response = await postCallFormDataNote(params);
    return response.data;
  } catch (error) {
    console.log("Error in SaveandSubmit ", error);
    throw error;
  }
};

export const ExportToExcel = async (params: any) => {
  try {
    const response = await postFileDownloadCall(
      urlConfig.PreworkExportToExcel,
      params
    );
    return response.data;
  } catch (error) {
    console.log("Error in ExportToExcel ", error);
    throw error;
  }
};
